import React from 'react';
import styled from 'styled-components';
import useImageQuery from '@/hooks/common/useImageQuery';
import { pdfjs, Document, Page } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface Props {
  viewScale: number;
  areaScale: number;
  shown: boolean;
  offset: { left: number; top: number };
  uri: string;
  fileType: string;
}

const WIDTH_ARRAY = [200, 350, 500, 650, 800];
const BASE_WIDTH = 420;
const ZoomViewBox = ({
  viewScale,
  areaScale,
  shown,
  offset,
  uri,
  fileType
}: Props) => {
  const {
    value: { imageUri: image }
  } = useImageQuery(uri);

  const zoomW = WIDTH_ARRAY[viewScale];
  const scale = 8 - areaScale;
  return shown ? (
    <Wrapper w={zoomW}>
      <div style={{ position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            left: `${offset.left * scale * -1}px`,
            top: `${offset.top * scale * -1}px`
          }}>
          <div>
            {fileType !== 'pdf' ? (
              <img
                src={image}
                style={{
                  width: `${BASE_WIDTH * scale}px`,
                  height: 'auto'
                }}
              />
            ) : (
              <Document file={image} error={() => <></>} loading={() => <></>}>
                <Page scale={scale} width={BASE_WIDTH} pageNumber={1} />
              </Document>
            )}
          </div>
        </div>
      </div>
    </Wrapper>
  ) : (
    <></>
  );
};

export default ZoomViewBox;
const Wrapper = styled.div<{ w: number }>`
  overflow: hidden;
  position: absolute;
  width: ${props => props.w}px;
  height: ${props => props.w}px;
  top: ${props => 545 - (props.w - 400)}px;
  left: 930px;
  background: #fff;
  z-index: 9;

  border: 1px solid #3fcc99;
  box-sizing: border-box;
`;
